import MenuSectionItem, { MenuSectionItemProps } from './MenuSectionItem';

import withInteractor from './MenuSectionItem.interactor';
import withPresenter from './MenuSectionItem.presenter';

export type { MenuSectionItemProps };
export default withInteractor(withPresenter(MenuSectionItem));
